module.exports = __webpack_public_path__ + "img/box7-img-3.fff74c28.png";